module.exports = __webpack_public_path__ + "images/c94d2b8e758ef5151dd2a960f76dfd9ad684d5f0de1f0b743360270d0f1373eb.svg";